import React from 'react';
import Radium from 'radium';
import RPT from 'prop-types';
import preload from 'redux-preload';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { Button, Well } from 'react-bootstrap';
import { Route } from 'react-router-dom';

import { fetchWorkshops } from '../components/workshops/actions';

import CategoryModal from './modal';
import OrderProgress from './progress';

@connect(({ workshops: { workshopCategories } }) => ({ workshopCategories }))
@preload(fetchWorkshops)
@Radium
export default class Categories extends React.Component {
  static propTypes = {
    match: RPT.shape({
      params: RPT.shape({
        id: RPT.string
      }),
      isExact: RPT.bool.isRequired,
      url: RPT.string.isRequired,
    }).isRequired,
    workshopCategories: RPT.arrayOf(RPT.shape({
      name: RPT.string.isRequired,
      workshops: RPT.arrayOf(RPT.shape)
    })).isRequired
  };

  getCategory(categoryID) {
    const { workshopCategories } = this.props;

    return workshopCategories.find(category => category.id === categoryID);
  }

  renderButton(category) {
    const { color, id, name, workshops } = category;
    const buttonStyles = styles({ color }).button;

    if (workshops.length === 0) return null;

    return (
      <LinkContainer
        to={`/objednavka/workshopy/${id}`}
        key={`button-${id}`}
        style={buttonStyles}
      >
        <Button>
          {name}
        </Button>
      </LinkContainer>
    );
  }

  renderModal = (props) => {
    const categoryID = parseInt(props.match.params.id, 10);

    return (
      <CategoryModal category={this.getCategory(categoryID)} />
    );
  }

  render() {
    const { match: { url, isExact }, workshopCategories } = this.props;

    return (
      <div>
        <OrderProgress active={isExact ? 1 : 2} />
        <div style={{ marginBottom: 20 }}>
          <Well style={{ padding: 7 }} className="hidden-xs">
            <h2>Chcete se stát pilotní školou?</h2>
            <div className="text-center">
              Na pilotních školách zorganizujeme všechny naše workshopy v průběhu školního roku.
            </div>
            <LinkContainer to="/objednavka/pilotni-skoly" style={{ margin: '10px 35% 0', width: '30%' }}>
              <Button bsStyle="primary">Více informací</Button>
            </LinkContainer>
          </Well>
          <h1>Jednotlivé workshopy</h1>
          Vyberte podle kategorie:

          <div data-tid="order-workshops-list" style={{ display: 'flex', flexFlow: 'row wrap', justifyContent: 'center' }}>
            { workshopCategories.map(this.renderButton) }
          </div>
          <Route path={`${url}/:id`} render={this.renderModal} />
        </div>
      </div>
    );
  }
}

const styles = ({ color }) => ({
  button: {
    margin: '15px 15px 0 0',
    width: '31.5%',
    minWidth: 150,
    borderColor: color,
    color: 'white',
    backgroundColor: color,
    paddingTop: 20,
    paddingBottom: 20,
    fontWeight: 500
  }
});



// WEBPACK FOOTER //
// ./src/browser/Feature/order/categories.jsx